// extracted by mini-css-extract-plugin
export default {"button":"DrawerDebtBubble_button__7VLvX","bulbAppear":"DrawerDebtBubble_bulbAppear__uX83a","title":"DrawerDebtBubble_title__Iy5mO","text":"DrawerDebtBubble_text__uQZlx"};